// Argon Dashboard 2 MUI Base Styles
import colors from "assets/theme-dark/base/colors";
import typography from "assets/theme-dark/base/typography";
import borders from "assets/theme-dark/base/borders";

// Soft UI Dashboard PRO helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { text, background, grey, inputColors } = colors;
const { size, fontWeightRegular } = typography;
const { borderWidth, borderRadius } = borders;

const inputBase = {
    styleOverrides: {
        root: {
            display: "flex !important",
            alignItems: "center !important",
            width: "100% !important",
            height: "auto !important",
            padding: `${pxToRem(8)} ${pxToRem(12)}`,
            fontSize: `${size.sm} !important`,
            fontWeight: `${fontWeightRegular} !important`,
            lineHeight: "1.4 !important",
            color: `${grey[100]} !important`,
            backgroundColor: `${background.dark} !important`,
            backgroundClip: "padding-box !important",
            border: `${borderWidth[1]} solid ${inputColors.borderColor.main}`,
            appearance: "none !important",
            borderRadius: borderRadius.md,
            transition: "box-shadow 150ms ease, border-color 150ms ease, padding 150ms ease !important",
        },

        input: {
            // width: "100% !important",
            height: pxToRem(22),
            paddingTop: "0 !important",
            paddingRight: "0 !important",
            paddingBottom: "0 !important",
            paddingLeft: pxToRem(6),

            "&::-webkit-input-placeholder": {
                color: `${text.main} !important`,
            },
        },
    },
};

export default inputBase;
